export default "__VITE_ASSET__jcEOT$3Y__"